<template>
  <div
    id="app"
    :class="{ fullScreen: fullScreen }"
    :style="{ height: `${clientHeight}px` }"
  >
    <NavBar></NavBar>
    <router-view></router-view>
    <div class="horizontal">
      <div class="icon"></div>
      <!-- <p>横屏浏览 体验更佳</p> -->
       <div class="font-bold"> 
        <div class="font-text">体验功能 需横屏浏览</div>
        <br/>
        <div class="font-text">在设置中打开屏幕「自动旋转」功能</div>
        <div class="font-text">横屏展示赛事中心内容</div>
        <!-- <div></div> -->
       </div>
       
    </div>
    <!--临时添加的活动结束遮罩-->
    <div v-if="true" class="tempEndMask">
        活动已结束
    </div>
  </div>
</template>

<script>
// import VConsole from 'vconsole';
// new VConsole();

import { mapState, mapMutations, mapActions } from 'vuex'
import NavBar from '@/views/navBar'
import * as api from '@/service/index'

export default {
  name: 'App',
  components: { NavBar },
  provide() {
    return {
      json_config: () => this.temp_config
    }
  },
  data() {
    return {
      clientWidth: document.documentElement.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      temp_config: {}
    }
  },
  computed: {
    ...mapState(['fullScreen', 'token'])
  },
  watch: {
    '$route.name': {
      handler(newVal) {
        this.setPagePropertyEvent({
          page: newVal
        })
      },
      immediate: true
    }
  },
  async created() {
    // 获取cookie中的xc-match-2025值
    let token = this.getCookie('xc-match-2025_token') || this.$route.query?.token;
    // let avatar = this.$route.query?.avatar
    // let taptapavatar = this.$route.query?.taptapavatar
    if(!token) {
      alert('token is null')
      return;
    }
    this.SET_TOKEN(token ? encodeURIComponent(token) : '')

    this.initTapdb()
    this.getConfig()

    // 回传头像
    // this.getupdateUseavatar(avatar, taptapavatar)
  },
  mounted() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.handleResize()
      })
    }
    this.handleResize()
  },
  methods: {
    ...mapMutations([
      'SET_TOKEN',
      'SET_SCALE',
      'SET_CLIENTSIZE',
      'SET_PAGE',
      'SET_LIVEROOMLIST'
    ]),
    ...mapActions(['setPagePropertyEvent']),
    handleResize() {
      this.clientWidth = document.documentElement.clientWidth
      this.clientHeight = document.documentElement.clientHeight
      if (this.clientWidth / this.clientHeight <= 5 / 3) {
        this.SET_SCALE(this.clientWidth / 1472)
      } else {
        this.SET_SCALE(this.clientHeight / 828)
      }

      this.SET_CLIENTSIZE({
        width: this.clientWidth,
        height: this.clientHeight
      })
    },
    isInIE() {
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        return true
      } else {
        return false
      }
    },
    getQueryVariable(variable) {
      let query = window.location.search.substring(1)
      let vars = query.split('&')
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=')
        if (pair[0] == variable) {
          return pair[1]
        }
      }
      return false
    },
    // 获取cookie的方法
    getCookie(name) {
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      if (parts.length === 2) {
        return parts.pop().split(';').shift()
      }
      return ''
    },
    async getConfig() {
      let response = await api.reqConfig()
      if (response.status == 200) {
        this.SET_LIVEROOMLIST(response.data.roomLive)
        this.temp_config = response.data
      }
    },
    afterLoadDB() {
      // 初始化
      var config = {
        appId: 'sausage',
        serverUrl:
          // 'https://tapdb-one-data-sdk-bj.cn-beijing.log.aliyuncs.com/logstores/tapdb-web-dev/track',
          'https://tapdb-one-data-sdk-bj.cn-beijing.log.aliyuncs.com/logstores/tapdb-web/track',
        isUseSLS: true,
        textContent: 'json',
        autoTrack: {
          pageShow: true,
          pageHide: true
        }
      }
      tapdb.init(config)
      this.setPagePropertyEvent({
        page: ''
      })
      tapdb.pvEvent()
    },
    initTapdb() {
      let self = this
      // IE下：
      var HEAD =
        document.getElementsByTagName('head')[0] || document.documentElement
      var script = document.createElement('script')
      script.setAttribute('type', 'text/javascript')
      script.setAttribute(
        'src',
        'https://website.xdcdn.net/module/tapdb.umd.min.js'
      )
      HEAD.appendChild(script)

      script.onload = function () {
        self.afterLoadDB()
      }
      script.onreadystatechange = function () {
        if (this.readyState === 'loaded' || this.readyState === 'complete') {
          self.afterLoadDB()
        }
      }
    },
    // async getupdateUseavatar(avatar, taptapavatar) {
    //   // 上传头像
    //   const storedAvatar = localStorage.getItem('DCavatar')
    //   const storedTaptapAvatar = localStorage.getItem('DCtaptapavatar')
      
    //   if (
    //     (!storedAvatar && !storedTaptapAvatar) ||
    //     avatar !== storedAvatar ||
    //     taptapavatar !== storedTaptapAvatar
    //   ) {
    //     const data = {
    //       avatar: avatar || 'Portrait1',
    //       taptapavatar: taptapavatar || ''
    //     }

    //     localStorage.setItem('DCavatar', data.avatar)
    //     localStorage.setItem('DCtaptapavatar', data.taptapavatar)

    //     try {
    //       await api.updateUseavatar(this.token, data)
    //     } catch (err) {
    //       console.log(err)
    //     }
    //   }
    // }
  }
}
</script>

<style lang="scss">
@import '~@/assets/common/base.scss';
@import '~@/assets/scss/app.scss';

.tempEndMask {
  position:absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 6vh;
  z-index: 10000;
}
</style>
